/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreateTemplate200Response } from '../models';
// @ts-ignore
import type { ListTemplates200Response } from '../models';
// @ts-ignore
import type { TrackerTemplateCreateDTO } from '../models';
// @ts-ignore
import type { TrackerTemplateUpdateDTO } from '../models';
/**
 * TrackerTemplateApi - axios parameter creator
 */
export const TrackerTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createTrackerTemplate
         * @param {TrackerTemplateCreateDTO} trackerTemplateCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate: async (trackerTemplateCreateDTO: TrackerTemplateCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackerTemplateCreateDTO' is not null or undefined
            assertParamExists('createTemplate', 'trackerTemplateCreateDTO', trackerTemplateCreateDTO)
            const localVarPath = `/api/nora/tracker/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackerTemplateCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteTrackerTemplate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTemplate', 'id', id)
            const localVarPath = `/api/nora/tracker/template/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getTrackerTemplateById
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTemplateById', 'id', id)
            const localVarPath = `/api/nora/tracker/template/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary listTrackerTemplates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/tracker/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateTrackerTemplate
         * @param {string} id 
         * @param {TrackerTemplateUpdateDTO} trackerTemplateUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: async (id: string, trackerTemplateUpdateDTO: TrackerTemplateUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTemplate', 'id', id)
            // verify required parameter 'trackerTemplateUpdateDTO' is not null or undefined
            assertParamExists('updateTemplate', 'trackerTemplateUpdateDTO', trackerTemplateUpdateDTO)
            const localVarPath = `/api/nora/tracker/template/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackerTemplateUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackerTemplateApi - functional programming interface
 */
export const TrackerTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackerTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createTrackerTemplate
         * @param {TrackerTemplateCreateDTO} trackerTemplateCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate(trackerTemplateCreateDTO: TrackerTemplateCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTemplate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate(trackerTemplateCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerTemplateApi.createTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteTrackerTemplate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerTemplateApi.deleteTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getTrackerTemplateById
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTemplate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerTemplateApi.getTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary listTrackerTemplates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTemplates200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerTemplateApi.listTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateTrackerTemplate
         * @param {string} id 
         * @param {TrackerTemplateUpdateDTO} trackerTemplateUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplate(id: string, trackerTemplateUpdateDTO: TrackerTemplateUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTemplate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplate(id, trackerTemplateUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerTemplateApi.updateTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrackerTemplateApi - factory interface
 */
export const TrackerTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackerTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary createTrackerTemplate
         * @param {TrackerTemplateApiCreateTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate(requestParameters: TrackerTemplateApiCreateTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTemplate200Response> {
            return localVarFp.createTemplate(requestParameters.trackerTemplateCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteTrackerTemplate
         * @param {TrackerTemplateApiDeleteTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate(requestParameters: TrackerTemplateApiDeleteTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getTrackerTemplateById
         * @param {TrackerTemplateApiGetTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateById(requestParameters: TrackerTemplateApiGetTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTemplate200Response> {
            return localVarFp.getTemplateById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary listTrackerTemplates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(options?: RawAxiosRequestConfig): AxiosPromise<ListTemplates200Response> {
            return localVarFp.listTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateTrackerTemplate
         * @param {TrackerTemplateApiUpdateTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate(requestParameters: TrackerTemplateApiUpdateTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTemplate200Response> {
            return localVarFp.updateTemplate(requestParameters.id, requestParameters.trackerTemplateUpdateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTemplate operation in TrackerTemplateApi.
 */
export interface TrackerTemplateApiCreateTemplateRequest {
    readonly trackerTemplateCreateDTO: TrackerTemplateCreateDTO
}

/**
 * Request parameters for deleteTemplate operation in TrackerTemplateApi.
 */
export interface TrackerTemplateApiDeleteTemplateRequest {
    readonly id: string
}

/**
 * Request parameters for getTemplateById operation in TrackerTemplateApi.
 */
export interface TrackerTemplateApiGetTemplateByIdRequest {
    readonly id: string
}

/**
 * Request parameters for updateTemplate operation in TrackerTemplateApi.
 */
export interface TrackerTemplateApiUpdateTemplateRequest {
    readonly id: string

    readonly trackerTemplateUpdateDTO: TrackerTemplateUpdateDTO
}

/**
 * TrackerTemplateApi - object-oriented interface
 */
export class TrackerTemplateApi extends BaseAPI {
    /**
     * 
     * @summary createTrackerTemplate
     * @param {TrackerTemplateApiCreateTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTemplate(requestParameters: TrackerTemplateApiCreateTemplateRequest, options?: RawAxiosRequestConfig) {
        return TrackerTemplateApiFp(this.configuration).createTemplate(requestParameters.trackerTemplateCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteTrackerTemplate
     * @param {TrackerTemplateApiDeleteTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTemplate(requestParameters: TrackerTemplateApiDeleteTemplateRequest, options?: RawAxiosRequestConfig) {
        return TrackerTemplateApiFp(this.configuration).deleteTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getTrackerTemplateById
     * @param {TrackerTemplateApiGetTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTemplateById(requestParameters: TrackerTemplateApiGetTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return TrackerTemplateApiFp(this.configuration).getTemplateById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary listTrackerTemplates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTemplates(options?: RawAxiosRequestConfig) {
        return TrackerTemplateApiFp(this.configuration).listTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateTrackerTemplate
     * @param {TrackerTemplateApiUpdateTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTemplate(requestParameters: TrackerTemplateApiUpdateTemplateRequest, options?: RawAxiosRequestConfig) {
        return TrackerTemplateApiFp(this.configuration).updateTemplate(requestParameters.id, requestParameters.trackerTemplateUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

